import UserDriverEditNotesRequest from "../../../../api/raily/user/driver/edit-notes/user-driver-edit-notes.request";
import UserDriverEditNotesParams from "./user-driver-edit-notes.params";

const create = (
  params: UserDriverEditNotesParams,
): UserDriverEditNotesRequest => {
  return {
    notes: params.notes,
    userUuid: params.userUuid,
  };
};

const userDriverEditNotesParamsFactory = {
  create,
};

export default userDriverEditNotesParamsFactory;
